import React from "react";
import Image from "../../components/general/Image";
import { PerfectCandidate, OrangeQuote } from "../../constants/ImagePaths";
import { CodingBackground } from "../../constants/ImagePaths";

const GetPerfectSection = () => {
    const backgroundStyles = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'initial',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000000'
    }
    return (
        <section className="!py-[50px]" style={backgroundStyles}>
            <div className="md:flex md:items-center lg:justify-center md:gap-[50px] --layout-padding max-width">
                <div className="md:w-[60%] lg:w-[45%]">
                    <p className="text-[18px] lg:text-[22px] italic"> Speed </p>
                    <h1 className="font-semibold text-[30px] lg:text-55 italic"> Build your team in a week, not a quarter </h1>
                    <p className="text-[14px] font-light">Why wait months to scale? We connect you with vetted, ready-to-start engineers in days — not weeks.</p>

                    <Image src={OrangeQuote} className='w-[20px] lg:w-[30px] mt-[50px] my-[10px]' alt="OrangeQuote" />
                    <p className="text-[14px] font-light">We went from a hiring gap to a high-performing dev team in just 7 days. Devhire made it seamless.</p>
                    <p className="text-[16px] font-semibold mt-[20px] lg:text-[20px]">— Sarah M., Director of Engineering</p>
                </div>
                <Image src={PerfectCandidate} className='w-full md:w-[40%] lg:w-[40%] my-[30px]' alt="HeroSection" />
            </div>
        </section>
    );
};
export default GetPerfectSection;